import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import {
  useSearchParams,
} from "react-router-dom";
import { useCast } from './../../cast/CastProvider';
import { getUrlForRelative } from '../../services/url';
import { v4 as uuidv4 } from 'uuid';
import Messenger from '../items/Messenger';
import CurrentTime from '../player/CurrentTime';
import { throttle } from '../../services/throttle';
import dayjs from 'dayjs';
import TR from './../../Trans';
import ForceChangePassword from '../dialogs/ForceChangePassword';
import { Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { Chromecast } from '@gameleap/capacitor-chromecast';
import { checkIfMobile } from '../../services/screen';
import { useMediaQuery } from 'react-responsive';
import { SafeArea } from 'capacitor-plugin-safe-area';
import ExternalViewCommands from './../../services/external';
import NewAccountDialog from '../dialogs/NewAccountDialog';
import ForceAcceptTerms from '../dialogs/ForceAcceptTerms';
import IosExternalLinkDialog from '../dialogs/IosExternalLinkDialog';
import MediaQuery from 'react-responsive';
import Landscape from './Landscape';
import { getOS, getPlatform, isDesktop, isPhone, isTablet, isSamsungBrowser } from './../../services/os';
import { setSafeAreas } from './../../services/safeareas';
import Error from './../items/Error';
import Message from './../items/Message';
import Portrait from './Portrait';
import AndroidSubDialog from '../dialogs/AndroidSubDialog';
import ExternalScreen from 'cordova-plugin-wkwebview-external-screen';
import { Capacitor } from '@capacitor/core';
import StrService from './../../services/str';
import { generateId } from './../../services/random';
import MuvikaService from './../../services/muvika';
import IntervalService from './../../services/intervals';
import navigationStore from '../../stores/navigation';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import accountStore from '../../stores/account';
import messageStore from '../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from './../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import songListStore from '../../stores/songList';
import singerStore from './../../stores/singers';
import timeoutsStore from '../../stores/timeouts';
import statusStore from './../../stores/status';
import homeStore from '../../stores/home';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import UpdateDialog from './../dialogs/UpdateDialog';
import MessageDialog from './../dialogs/MessageDialog';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from './../../attrs';
import bgFiltersStore from '../../stores/bgFilters';
import bgStylesStore from '../../stores/bgStyles';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgSearchStore from '../../stores/bgSearch';
import bgPlaylistsStore from './../../stores/bgPlaylists';
import { useLocalStorage } from '../../services/useLocalStorage';
import songbookQueueStore from '../../stores/songbookQueue';

const songbookInterval = 10000;
const newTracksInterval = 60 * 60 * 1000;

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function resetStores(isWaitingLoggedIn = false) {
  console.log("isWaitingLoggedIn: false");
  accountStore.getState().reset();
  catalogStore.getState().reset();
  environmentStore.getState().reset();
  favoritesStore.getState().reset();
  messageStore.getState().reset();
  musicPlayerStore.getState().reset();
  musicStore.getState().reset();
  navigationStore.getState().reset();
  newsStore.getState().reset();
  homeStore.getState().reset();
  newTracksStore.getState().reset();
  performanceStore.getState().reset();
  playerStore.getState().reset();
  searchStore.getState().reset();
  sessionStore.setState({
    isSessionOpening: false,
    isThrownOut: false,
    isLoggedIn: false,
    isAckSmartQ: false,
    externalWindowHandler: null,
    isLoginSeqErrors: false,
    isLoginSeqError: false,
    isWaiting: false,
    requestCount: 0,
    isWaitingLoggedIn: isWaitingLoggedIn,
    isAndroidSubMode: false
  });
  settingsStore.getState().reset();
  singersStore.getState().reset();
  songListStore.getState().reset();
  timeoutsStore.getState().reset();
  IntervalService.clearAllIntervals();
  IntervalService.clearSongbookInterval();
  IntervalService.clearNewTracksInterval();
  IntervalService.clearAllStreamUrlTimeouts();
  IntervalService.clearSubInterval();
  bgFiltersStore.getState().reset();
  bgStylesStore.getState().reset();
  bgPerformanceStore.getState().reset();
  bgSearchStore.getState().reset();
  bgPlaylistsStore.getState().reset();
  musicPlayerStore.getState().reset();
  
}

const forceRefreshTime = 5000;

function MuvikaMessenger() {

  const [queryParameters] = useSearchParams();

  const itemsOnPage = 25;
  const session = sessionStore((state) => state.session);
  const isWaitingLoggedIn = sessionStore((state) => state.isWaitingLoggedIn);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isSessionOpen = sessionStore((state) => state.isSessionOpen);
  const isSongbookPublicMode = sessionStore((state) => state.isSongbookPublicMode);
  const isSongbookLoggedIn = sessionStore((state) => state.isSongbookLoggedIn);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const playQueue = performanceStore((state) => state.playQueue);
  const getPlayQueue = performanceStore((state) => state.getPlayQueue);
  const history = performanceStore((state) => state.history);
  const getHistory = performanceStore((state) => state.getHistory);
  const clearError = messageStore((state) => state.clearError);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const setPlayIsOn = performanceStore((state) => state.setPlayIsOn);
  const singers = singerStore((state) => state.singers);
  const getSingers = singerStore((state) => state.getSingers);
  const addPerformanceFromSongbook = performanceStore((state) => state.addPerformanceFromSongbook);
  const setError = messageStore((state) => state.setError);
  const setMessage = messageStore((state) => state.setMessage);
  const addSingerLocally = singersStore((state) => state.addSingerLocally);
  const clearPlayQueue = performanceStore((state) => state.clearPlayQueue);
  const addSongbookId = performanceStore((state) => state.addSongbookId);
  const editPerformance = performanceStore((state) => state.editPerformance);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const swapPerformances = performanceStore((state) => state.swapPerformances);
  const getLatest = newTracksStore((state) => state.getLatest);
  const newTracks = newTracksStore((state) => state.tracks);
  const favorites = favoritesStore((state) => state.tracks);
  const getFavorites = favoritesStore((state) => state.getFavorites);
  const musicPlayQueue = bgPerformanceStore((state) => state.playQueue);
  const getMusicPlayQueue = bgPerformanceStore((state) => state.getPlayQueue);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  //const currentTime = playerStore((state) => state.currentTime);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  //const countdown = performanceStore((state) => state.countdown);
  const setCurrentTitle = performanceStore((state) => state.setCurrentTitle);
  const setPlayQueueTrackList = performanceStore((state) => state.setPlayQueueTrackList);
  const setNextSingerTitle = performanceStore((state) => state.setNextSingerTitle);
  const setNewTracksTitle = newTracksStore((state) => state.setNewTracksTitle);
  const currentError = messageStore((state) => state.currentError);
  const emptyPlayer = playerStore((state) => state.empty);
  const setAppStatus = statusStore((state) => state.setAppStatus);
  const isUpdateable = statusStore((state) => state.isUpdateable);
  const isForceUpdate = statusStore((state) => state.isForceUpdate);
  const messageTitle = statusStore((state) => state.messageTitle);
  const message = statusStore((state) => state.message);
  const isMessage = statusStore((state) => state.isMessage);
  const clearMessage = statusStore((state) => state.clearMessage);
  const clearUpdate = statusStore((state) => state.clearUpdate);
  const setExternalWindowAvailable = playerStore((state) => state.setExternalWindowAvailable);
  const setIsInExternalWindow = playerStore((state) => state.setIsInExternalWindow);
  const setIsInIosExternalScreen = playerStore((state) => state.setIsInIosExternalScreen);
  const setIsInAndroidExternalScreen = playerStore((state) => state.setIsInAndroidExternalScreen);
  const setCastAvailable = playerStore((state) => state.setCastAvailable);
  const setIsCasting = playerStore((state) => state.setIsCasting);
  const setIsRequestingCasting = playerStore((state) => state.setIsRequestingCasting);
  const isUnsubscriptionDialogShown = navigationStore((state) => state.isUnsubscriptionDialogShown);
  const setUnsubscriptionDialogShown = navigationStore((state) => state.setUnsubscriptionDialogShown);
  const openSessionAndOneTimeLogin = sessionStore((state) => state.openSessionAndOneTimeLogin);
  const openSessionAndOneTimeLoginWithUsername = sessionStore((state) => state.openSessionAndOneTimeLoginWithUsername);
  const isSessionOpening = sessionStore((state) => state.isSessionOpening);
  const timeDiff = accountStore((state) => state.timeDiff);
  const isMusicListSet = musicStore((state) => state.isSet);
  const musicHistory = bgPerformanceStore((state) => state.history);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const getMusicHistory = bgPerformanceStore((state) => state.getHistory);
  const filters = bgFiltersStore((state) => state.filters);
  const getFilters = bgFiltersStore((state) => state.getFilters);
  const musicPlayLists = bgPerformanceStore((state) => state.playLists);
  const getMusicPlayLists = bgPerformanceStore((state) => state.getPlayLists);
  const logout = sessionStore((state) => state.logout);
  const setAccount = accountStore((state) => state.setAccount);
  const setBasicScreen = playerStore((state) => state.setBasicScreen);
  const isInBasicScreen = playerStore((state) => state.isInBasicScreen);
  const logoutChange = sessionStore((state) => state.logoutChange);
  const isQueueingOn = songbookQueueStore((state) => state.isQueueingOn);
  const setQueue = songbookQueueStore((state) => state.setQueue);
  const addIpCount = songbookQueueStore((state) => state.addIpCount);
  const addIdCount = songbookQueueStore((state) => state.addIdCount)
  const setQueueingOn = songbookQueueStore((state) => state.setQueueingOn);
  const isSongbookQueueWaiting = songbookQueueStore((state) => state.isWaiting);

  const handleAndroidSubDialogOk = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      ExternalViewCommands.loadBasicToAndroidExternalScreen();
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      ExternalViewCommands.loadBasicToIosExternalScreen();
    }
    logoutChange(account.username, androidSubOneTimeLoginCode);
    setAndroidSubOneTimeLoginCode(null);
    setIsAndroidSubDialogOpen(false);
  };

  const [isForceAcceptTermsDialogOpen, setIsForceAcceptTermsDialogOpen] = useState(false);

  const logoutNow = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      ExternalViewCommands.loadBasicToAndroidExternalScreen();
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      ExternalViewCommands.loadBasicToIosExternalScreen();
    }
    logout();
  };

  const handleCloseForceAcceptTermsDialog = () => {
    setIsForceAcceptTermsDialogOpen(false);
    resetStores();
    logoutNow();
  };

  const [isForceChangePasswordDialogOpen, setIsForceChangePasswordDialogOpen] = useState(false);

  const handleCloseForceChangePasswordDialog = () => {
    setIsForceChangePasswordDialogOpen(false);
    resetStores();
    logoutNow();
  };

  const [isAndroidSubDialogOpen, setIsAndroidSubDialogOpen] = useState(false);
  const [androidSubOneTimeLoginCode, setAndroidSubOneTimeLoginCode] = useState(null);

  const handleOpenAndroidSubDialog = () => {


    MuvikaService.createAccountLink(sessionToken, account.username, "one_time_login")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
        } else {
          setAndroidSubOneTimeLoginCode(res.data.data.code);
          setIsAndroidSubDialogOpen(true);
        }
      })
      .catch(function () { });
  };

  const handleCloseAndroidSubDialog = () => {


    setIsAndroidSubDialogOpen(false);
  };

  const [isIosExternalLinkDialogOpen, setIsIosExternalLinkDialogOpen] = useState(false);

  const handleOpenIosExternalLinkDialog = () => {


    setIsIosExternalLinkDialogOpen(true);
  };

  const handleCloseIosExternalLinkDialog = () => {


    setIsIosExternalLinkDialogOpen(false);
  };

  const [isNewAccountDialogOpen, setIsNewAccountDialogOpen] = useState(false);

  const handleOpenNewAccountDialog = () => {


    setIsNewAccountDialogOpen(true);
  };

  const handleCloseNewAccountDialog = () => {


    setIsNewAccountDialogOpen(false);
  };

  const isCheckMobile = useMediaQuery({ query: '(max-width: 967px)' });

  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  useEffect(() => {
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, [isPortrait]);

  const [isSubscribeDialogOpen, setIsSubscribeDialogOpen] = useState(false);

  const handleOpenSubscribeDialog = () => {


    setIsSubscribeDialogOpen(true);
  };

  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);

  const handleOpenUpdateDialog = () => {


    setIsUpdateDialogOpen(true);
  };

  const handleCloseUpdateDialog = () => {


    setIsUpdateDialogOpen(false);
    clearUpdate();
  };

  const [isMessageDialogOpen, setIsMessageDialogOpen] = useState(false);

  const handleOpenMessageDialog = () => {


    setIsMessageDialogOpen(true);
  };

  const handleCloseMessageDialog = () => {


    setIsMessageDialogOpen(false);
    clearMessage();
  };

  const sendStatusReport = () => {



  };

  const renderPeriodically = () => {


    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  };

  const toHours = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / (3600));
    if (hours > 0) {
      return hours;
    }
  };

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / (3600));
    var minutes = Math.floor(sec_num / 60) % 60;
    if (hours > 0) {
      return hours + "h " + minutes;
    } else {
      return minutes;
    }
  };

  const checkIfBeforeNow = (dateStr) => {


    var now = new Date();
    var date = new Date(dateStr);
    now.setMinutes(now.getMinutes() + Math.round(timeDiff));
    return date < now;
  };

  const showSubscribeDialogIfNecessary = () => {


    if (!isUnsubscriptionDialogShown) {
      if (account && settings) {
        if (!settings.account_pin && account.subscription.valid == 0 && account.subscription.order_info.actions.includes("subscribe")) {
          emptyPlayer();
          setIsSubscribeDialogOpen(true);
        }
      }
    }
  };

  const orientationChangeEvents = () => {


    window.dispatchEvent(new Event('resize'));
  };

  const { chromecast } = useCast();

  const checkCast = () => {


    if (!Capacitor.isNativePlatform()) {
      console.log("checking cast");
      console.log("chromecast", chromecast);
      console.log("chromecast", chromecast._player);
      setCastAvailable(chromecast.available);
      if (chromecast.connected) {
        setIsRequestingCasting(false);
        setIsCasting(true);
        if (chromecast._mediaSession) {
          if (chromecast.src.length > 0 && !chromecast._mediaSession.activeTrackIds) {
            setError(sessionToken, 0, TR.cm_chromecast_casting_error);
            console.log(chromecast);
            chromecast.off();
            chromecast.disconnect();
          }
        }
      } else {
        setIsCasting(false);
      }
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      setCastAvailable(true);
    }
  };

  const checkExternalScreen = () => {
    if (!Capacitor.isNativePlatform() && isDesktop()) {
      setExternalWindowAvailable(true);
      window.dispatchEvent(new Event('refitbuttons'));
    }
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      ExternalScreen.checkAvailability(function (isAvailable) {
        if (isAvailable) {
          setExternalWindowAvailable(true);
          window.dispatchEvent(new Event('refitbuttons'));
          if (!playerStore.getState().isInIosExternalScreen && !playerStore.getState().isExternalWaiting && sessionStore.getState().isLoggedIn && !playerStore.getState().isInBasicScreen) {
            const exUrl = accountStore.getState().urls.url_ext_screen;
            const exUrlBasic = exUrl + "basic/";
            StrService.get(exUrlBasic, {})
              .then(function (res) {
                ExternalScreen.loadHTML(exUrl, res.data);
                playerStore.getState().setBasicScreen(true);
              });
          }
        } else {
          if (playerStore.getState().isInIosExternalScreen) {
            playerStore.getState().setIsPlaying(false);
            setIsInIosExternalScreen(false);
          }
          ExternalScreen.checkOut();
          setExternalWindowAvailable(false);
          setIsInExternalWindow(false);
        }
      });
    }
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      AndroidExternalScreen.checkAvailability().then(res => {
        if (res.value) {
          setExternalWindowAvailable(true);
          window.dispatchEvent(new Event('refitbuttons'));
          if (!playerStore.getState().isInAndroidExternalScreen && !playerStore.getState().isExternalWaiting && sessionStore.getState().isLoggedIn && !playerStore.getState().isInBasicScreen) {
            const exUrl = accountStore.getState().urls.url_ext_screen;
            console.log("externalUrl", exUrl);
            const exUrlBasic = exUrl + "basic/";
            StrService.get(exUrlBasic, {})
              .then(function (res) {
                AndroidExternalScreen.loadHTML({ baseUrl: exUrl, html: res.data });
                playerStore.getState().setBasicScreen(true);
              });
          }
        } else {
          setExternalWindowAvailable(false);
          setIsInExternalWindow(false);
          setIsInAndroidExternalScreen(false);
        }
      })
        .catch(function (e) { console.log("android check availability " + e); });
    }
  };

  const handleCloseSubscribeDialog = () => {


    setUnsubscriptionDialogShown(true);
    setIsSubscribeDialogOpen(false);
  };

  const processSongbookRequests = (items) => {
    let ackItems = [];
    let addUniqueIds = [];
    let ackPerformances = [];
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (!ackItems.includes(item.id) && !performanceStore.getState().songbookIds.includes(item.id)) {
        switch (item.req_type) {
          case "add":
            let uniqueId = generateId(8);
            addUniqueIds.push(uniqueId);
            break;
          default:
            addUniqueIds.push("");
        }
        ackItems.push(item.id);
        ackPerformances.push(item);
      }
    }
    if (ackItems.length > 0) {
      MuvikaService.ackSongbookRequest(sessionToken, ackItems, addUniqueIds)
        .then(async function (res) {
          if (!res.data.error) {
            for (let i = 0; i < ackPerformances.length; i++) {
              let item = ackPerformances[i];
              if (!performanceStore.getState().songbookIds.includes(item.id)) {
                console.log("handling item", item)
                switch (item.req_type) {
                  case "add":
                    let uniqueId = addUniqueIds[i];
                    item.performance.unique_id = uniqueId;
                    let res = await MuvikaService.createSinger(sessionToken, item.performance.profile.name, "", "");
                    if (res.data.data.id) {
                      addSingerLocally(res.data.data);
                      setIsAutoPlayOn(true);
                      console.log("adding performance from songbook");
                      addPerformanceFromSongbook(sessionToken, { ...item.performance });
                    }
                    break;
                  case "edit":
                    editPerformance(sessionToken, item.performance.unique_id, item.performance.profile, item.performance.pitch, item.performance.track);
                    break;
                  case "del":
                    let uniqueIdsDel = item.unique_ids;
                    for (let j = 0; j < uniqueIdsDel.length; j++) {
                      deletePerformance(sessionToken, uniqueIdsDel[j]);
                    }
                    break;
                  case "swap":
                    let uniqueIdsSwap = item.unique_ids;
                    let performanceId1 = uniqueIdsSwap[0];
                    let performanceId2 = uniqueIdsSwap[1];
                    swapPerformances(sessionToken, performanceId1, performanceId2);
                    break;
                  case "clear":
                    clearPlayQueue(sessionToken);
                    setMessage(TR.cm_playlist_cleared_via_songbook);
                    break;
                }
                addSongbookId(item.id);
              }
            }
          }
        })
        .catch(function () { });
    }
  };

  const getSongbookRequests = () => {
    MuvikaService.getSongbookRequests(sessionToken)
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let items = res.data.data.items;
          console.log("songbookRequests", res.data.data, items, isQueueingOn);
          let addingReqs = [];
          let otherReqs = [];
          for (let i = 0; i < items.length; i++) {
            let item = items[i];
            console.log("handling item", item)
            switch (item.req_type) {
              case "add":
                item.isNew=true;
                addingReqs.push(item);
                break;
              case "edit":
                otherReqs.push(item);
                break;
              case "del":
                otherReqs.push(item);
                break;
              case "swap":
                break;
              case "clear":
                otherReqs.push(item);
                break;
            }
          }
          console.log("songbookQueueStore.getState().isWaiting", songbookQueueStore.getState().isWaiting)
          if (songbookQueueStore.getState().isQueueingOn) {
            if(!songbookQueueStore.getState().isWaiting){
              songbookQueueStore.getState().setQueue(addingReqs);
              processSongbookRequests(otherReqs);
            }
          } else {
            songbookQueueStore.getState().setHistory(addingReqs);
            processSongbookRequests(items);
          }
        }
      })
      .catch(function () { });
  };

  useEffect(() => {
    showSubscribeDialogIfNecessary();
  }, [currentError]);

  useEffect(() => {
    showSubscribeDialogIfNecessary();
  }, [isUnsubscriptionDialogShown]);

  useEffect(() => {
    if (isUpdateable && isForceUpdate) {
      setTimeout(() => {
        window.location.reload();
      }, forceRefreshTime);
    }
    setIsUpdateDialogOpen(isUpdateable);
  }, [isUpdateable]);

  useEffect(() => {
    setIsMessageDialogOpen(isMessage);
  }, [isMessage]);

  const checkIfUnSubbed = () => {
    if (Capacitor.isNativePlatform()) {
      if (accountStore.getState().account) {
        if (accountStore.getState().account.subscription.valid == 0 && accountStore.getState().account.subscription.order_info.actions.includes("subscribe")) {
          accountStore.getState().getAccount(sessionToken);
        }
      }
    }
  };

  const orientationEvents = () => {
    window.addEventListener("orientationchange", function () {
      window.dispatchEvent(new Event('refitbuttons'));
      window.dispatchEvent(new Event('resize'));
    }, false);
    if (window.screen.orientation) {
      window.screen.orientation.addEventListener(
        'change',
        function () {
          window.dispatchEvent(new Event('refitbuttons'));
          window.dispatchEvent(new Event('resize'));
        },
        false
      );
    }
  };

  async function getWindowManagementPermissionState() {
    let state;
    // The new permission name.
    try {
      ({ state } = await navigator.permissions.query({
        name: "window-management",
      }));
    } catch (err) {
      return `${err.name}: ${err.message}`;
    }
    return state;
  }

  useEffect(() => {
    console.log("loginAs", queryParameters);
    let loginCode = queryParameters.get("login_code");
    let loginUsername = queryParameters.get("username");
    if (loginCode && loginUsername) {
      if (!isSessionOpening) {
        if (isLoggedIn) {
          logoutChange(loginUsername, loginCode, true);
        } else {
          openSessionAndOneTimeLoginWithUsername(loginUsername, loginCode, false, true);
        }
      }
    }
  }, [queryParameters]);

  useEffect(() => {
    if (isLoggedIn && !isSongbookLoggedIn && !isSongbookPublicMode) {
      clearError();
      if (!newTracks) {
        getLatest(sessionToken, 50);
      }
      if (!account) {
        getAccount(sessionToken);
      }
      if (!playQueue) {
        getPlayQueue(sessionToken);
      }
      if (!musicPlayQueue) {
        getMusicPlayQueue(sessionToken);
      }
      if (!history) {
        getHistory(sessionToken);
      }
      if (!settings) {
        getSettings(sessionToken);
      }
      if (!favorites) {
        getFavorites(sessionToken, itemsOnPage);
      }
      if (!singers) {
        getSingers(sessionToken);
      }
      if (!filters) {
        getFilters(sessionToken);
      }
      if (!musicPlayQueue) {
        getMusicPlayQueue(sessionToken);
      }
      if (!musicHistory) {
        getMusicHistory(sessionToken);
      }
      if (!filters) {
        getFilters(sessionToken);
      }
      if (!musicPlayLists) {
        getMusicPlayLists(sessionToken);
      }
      let testing = queryParameters.get("testing");
      if (testing) {
        switch (testing) {
          case "empty":
            window.TestService.emptyPerformanceList();
            break;
          case "playqueue":
            window.TestService.setTestPerformanceList();
            break;
          case "empty_music":
            window.TestService.emptyMusicList();
            break;
          case "playqueue_music":
            window.TestService.setTestMusicList();
            break;
        }
      }


      /* let listener;

      const start = async () => {
        const vol = await VolumeControl.getVolumeLevel();
        console.log("Initial volume:", vol.value);
        await VolumeControl.addListener('volumeButtonPressed', (event) => {
          console.log('Volume button pressed:', event.direction);
          VolumeControl.getVolumeLevel().then(volume => {
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
              console.log("Volume changed:", volume.value);
              if (!musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
                musicPlayerStore.getState().setVolume(volume.value);
                if (settingsStore.getState().settings) {
                  let newSettings = { ...settingsStore.getState().settings };
                  newSettings.music_volume = volume.value * 100;
                  settingsStore.getState().setSettings(sessionStore.getState().sessionToken, newSettings, false);
                }
              } else {
                playerStore.getState().setVolume(volume.value);
                if (settingsStore.getState().settings) {
                  let newSettings = { ...settingsStore.getState().settings };
                  newSettings.volume = volume.value * 100;
                  settingsStore.getState().setSettings(sessionStore.getState().sessionToken, newSettings, false);
                }
              }
            }
          });
        });

        // Then start watching
        await VolumeControl.watchVolume({
          disableSystemVolumeHandler: true, // iOS only
          suppressVolumeIndicator: true,    // Android only
        });
      }

      start(); */


      setPaddingBottom("muvika-music-list", -50);
      orientationEvents();
      let subInterval = setInterval(checkIfUnSubbed, 10000);
      IntervalService.setSubInterval(subInterval);
      window.addEventListener("orientationchange", orientationChangeEvents);
      let castCheckInterval = setInterval(checkCast, 5000);
      IntervalService.setCastCheckInterval(castCheckInterval);
      let externalScreenInterval = setInterval(checkExternalScreen, 5000);
      IntervalService.setExternalScreenInterval(externalScreenInterval);
      console.log("sending app status");
      setAppStatus(sessionToken, "mainwindow");
      let intervalNewTracks = setInterval(() => getLatest(sessionToken, 50), newTracksInterval);
      IntervalService.setSongbookInterval(intervalNewTracks);
    }
    SafeArea.getSafeAreaInsets().then(({ insets }) => {


      console.log("insets: " + JSON.stringify(insets));
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
        navigationStore.getState().setSafeArea({
          top: 0,
          bottom: 0,
          left: insets.left,
          right: insets.right,
        });
      }
      else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        navigationStore.getState().setSafeArea({
          top: 0,
          bottom: insets.bottom,
          left: insets.left,
          right: insets.right,
        });
      } else {
        document.body.style.paddingTop = insets.top + "px";
        navigationStore.getState().setSafeArea(insets);
      }
    });
  }, []);

  useEffect(() => {
    if (!isMusicListSet) {
      if (singers) {
        if (singers.length > 0) {
          //getMusicList(sessionToken, singers[0]);
        }
      }
    }
  }, [singers]);

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  useEffect(() => {
    if (settings) {
      setQueueingOn(settings.sb_prequeue_enabled == 1);
      setPlayIsOn(settings.autoplay_enabled);
      if (settings.sb_enabled) {
        IntervalService.clearSongbookInterval();
        let interval = setInterval(getSongbookRequests, songbookInterval);
        IntervalService.setSongbookInterval(interval);
      } else {
        IntervalService.clearSongbookInterval();
      }
      if (settings.theme) {
        console.log("setting theme b", settings.theme);
        if (settings.theme === "dark") {
          document.documentElement.classList.remove("light-theme");
          localStorage.setItem(muvikaAttrs.service + "-theme", JSON.stringify("dark"));
        } else {
          document.documentElement.classList.add("light-theme");
          localStorage.setItem(muvikaAttrs.service + "-theme", JSON.stringify("light"));
        }
      } else {
        console.log("setting theme", theme);
        if (!theme || theme === "dark") {
          document.documentElement.classList.remove("light-theme");
        } else {
          document.documentElement.classList.add("light-theme");
        }
      }
    }
  }, [settings]);

  useEffect(() => {
    showSubscribeDialogIfNecessary();
    if (account) {
      if (account.force_pw_change) {
        setIsForceChangePasswordDialogOpen(true);
      }
      if (account.force_accept_terms) {
        setIsForceAcceptTermsDialogOpen(true);
      }
    }
  }, [account]);

  return (
    <div>
    </div>
  );
}

export default MuvikaMessenger;
